import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  Operation,
} from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { RetryLink } from '@apollo/client/link/retry';
import AuthService from 'services/Auth';
import { getLanguageId } from './authHeaders';
import { createOktaServiceTokenLink } from './createOktaServiceTokenLink';

const getUserId = () => AuthService.getLocalUser()?.id || '';
const importUrl = `${window._env_.IMPORTER_API_URL}/graphql`;

const isFileUpload = (operation: Operation) => {
  return (
    operation.variables &&
    Object.keys(operation.variables).some(key => {
      return operation.variables[key] instanceof File;
    })
  );
};

const importerAuthContext = createOktaServiceTokenLink({
  projectName: 'importer-api',
  getExtraHeaders: () => ({
    'user-id': getUserId(),
    'language-id': getLanguageId(),
  }),
});

const uploadLinkWithAuth = ApolloLink.from([
  importerAuthContext,
  createUploadLink({
    uri: importUrl,
  }),
]);

const httpLink = ApolloLink.from([
  importerAuthContext,
  new HttpLink({
    uri: importUrl,
  }),
]);

const importerLink = new RetryLink({ attempts: { max: 1 } }).split(
  isFileUpload,
  uploadLinkWithAuth,
  httpLink,
);

const importerClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: importerLink,
  name: 'importer-api-client',
});

export default importerClient;
